export default "__VITE_ASSET__05a00a27__"